'use client';

export { Slot } from '@radix-ui/react-slot';
